"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderChildIdsInput = exports.renderParentIdsInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@framework/types");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_2 = require("../../../../../types");
const inputs_1 = require("../../../../../inputs");
const renderParentIdsInput = (formatMessage) => ({
    [types_2.ServiceType.ADMIN]: ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "parentIds", controller: "contracts", multiple: true, fetchData: {
            contractType: [types_1.TokenType.ERC998],
            contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
            contractModule: [types_1.ModuleType.HIERARCHY],
        }, label: formatMessage({ id: "form.labels.parent" }) })),
    [types_2.ServiceType.OFFICE]: ((0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantContractsInput, { name: "parentIds", multiple: true, fetchData: {
            contractType: [types_1.TokenType.ERC998],
            contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
            contractModule: [types_1.ModuleType.HIERARCHY],
        }, label: formatMessage({ id: "form.labels.parent" }) })),
});
exports.renderParentIdsInput = renderParentIdsInput;
const renderChildIdsInput = (formatMessage) => ({
    [types_2.ServiceType.ADMIN]: ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "childIds", controller: "contracts", multiple: true, fetchData: {
            contractType: [types_1.TokenType.ERC20, types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
            contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
            contractModule: [types_1.ModuleType.HIERARCHY],
        }, label: formatMessage({ id: "form.labels.child" }) })),
    [types_2.ServiceType.OFFICE]: ((0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantContractsInput, { name: "childIds", multiple: true, fetchData: {
            contractType: [types_1.TokenType.ERC20, types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
            contractStatus: [types_1.ContractStatus.ACTIVE, types_1.ContractStatus.NEW],
            contractModule: [types_1.ModuleType.HIERARCHY],
        }, label: formatMessage({ id: "form.labels.child" }) })),
});
exports.renderChildIdsInput = renderChildIdsInput;
//# sourceMappingURL=schemas.js.map